<template>
    <div id="application-permissions">
        <ApplicationPermissionCRU />
        <v-layout wrap justify-center>
            <v-flex>
                <v-toolbar flat>
                    <v-toolbar-title>Application Permissions</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        class="drei_60-btn mb-2 mt-3 mr-1"
                        :disabled="loading"
                        @click="getPermissions"
                    >
                        neu laden
                    </v-btn>
                    <v-btn
                        outlined
                        class="drei_60-btn mb-2 mt-3 ml-1"
                        :disabled="loading"
                        @click="addPermission"
                    >
                        hinzufügen
                    </v-btn>
                </v-toolbar>
            </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
            <v-flex>
                <ApplicationPermissionsComponent />
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ApplicationPermissionsComponent from '@/components/application/ApplicationPermissions.vue';
import ApplicationPermissionCRU from '@/components/application/ApplicationPermissionCRU.vue';

export default {
    name: 'ApplicationPermissions',
    components: {
        ApplicationPermissionsComponent,
        ApplicationPermissionCRU,
    },
    computed: mapState('applicationPermissions', ['loading']),
    methods: {
        ...mapActions('applicationPermissions', ['getPermissions', 'addPermission']),
    },
    mounted() {
        this.getPermissions();
    },
};

</script>
<style scoped lang="scss"></style>
